var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"mb-4 ml-2",attrs:{"color":"secondary"},on:{"click":_vm.loginAuth0}},[_vm._v("Auth0")])
}
var staticRenderFns = []

export { render, staticRenderFns }